import { cn } from "@/lib/utils";

// Nymbl status language — one consistent badge system reused across
// certifications, roles, competencies, releases, people. Tinted surface
// + colored dot + label, per the Nymbl design system.
export type StatusTone = "success" | "warning" | "danger" | "info" | "navy" | "neutral";

const toneStyles: Record<StatusTone, { wrap: string; dot: string }> = {
  success: { wrap: "bg-success-bg text-success-foreground", dot: "bg-success" },
  warning: { wrap: "bg-warning-bg text-warning-foreground", dot: "bg-warning" },
  danger: { wrap: "bg-danger-bg text-danger-foreground", dot: "bg-danger" },
  info: { wrap: "bg-info-bg text-info-foreground", dot: "bg-info" },
  navy: { wrap: "bg-accent text-primary", dot: "bg-primary" },
  neutral: { wrap: "bg-muted text-muted-foreground", dot: "bg-muted-foreground" },
};

interface StatusPillProps {
  tone: StatusTone;
  label: string;
  className?: string;
}

export function StatusPill({ tone, label, className }: StatusPillProps) {
  const styles = toneStyles[tone];
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium",
        styles.wrap,
        className,
      )}
    >
      <span className={cn("size-1.5 shrink-0 rounded-full", styles.dot)} />
      {label}
    </span>
  );
}
